import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PreviewCaseModal from './PreviewCaseModal';

const PreviewCaseStudies = ({ items }) => {
  const [activeCase, setActiveCase] = useState(null);

  const openCase = (item) => setActiveCase(item);
  const closeCase = () => setActiveCase(null);

  return (
    <section className="site-refresh__section" id="cases">
      <div className="site-refresh__shell">
        <div className="site-refresh__section-top">
          <h2 className="site-refresh__section-title">Cases em destaque</h2>
          <Link to="/Cases" className="site-refresh__text-link">
            Ver todos os cases
            <span className="site-refresh__arrow" aria-hidden="true">
              →
            </span>
          </Link>
        </div>

        <div className="site-refresh__case-grid">
          {items.map((item) => (
            <article key={item.title} className="site-refresh__case-card">
              <button
                type="button"
                className="site-refresh__case-trigger"
                onClick={() => openCase(item)}
                aria-label={`Ver case ${item.title}`}
              >
                <img className="site-refresh__case-image" src={item.image} alt="" />
                <div className="site-refresh__case-body">
                  <h3 className="site-refresh__case-title">{item.title}</h3>
                  <div className="site-refresh__case-category">{item.category}</div>
                  <p className="site-refresh__case-text">{item.description}</p>
                  <span className="site-refresh__case-link">
                    Ver case
                    <span className="site-refresh__arrow" aria-hidden="true">
                      →
                    </span>
                  </span>
                </div>
              </button>
            </article>
          ))}
        </div>
      </div>

      <PreviewCaseModal caseItem={activeCase} onClose={closeCase} />
    </section>
  );
};

export default PreviewCaseStudies;
